(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@jasperoosthoek/react-toolbox"] = factory();
	else
		root["@jasperoosthoek/react-toolbox"] = factory();
})(this, () => {
return 